import { useSessionStorage } from "usehooks-ts";

const IS_FIRST_SESSION_KEY = "isFirstSession";

export function clearIsFirstSessionSessionStorage() {
  try {
    window.sessionStorage.removeItem(IS_FIRST_SESSION_KEY);
  } catch (error) {
    console.error("Error clearing session storage:", error);
  }
}

export function setIsFirstSessionSessionStorage(isFirstSession: boolean) {
  try {
    window.sessionStorage.setItem(IS_FIRST_SESSION_KEY, String(isFirstSession));
  } catch (error) {
    console.error("Error setting session storage:", error);
  }
}

export function useIsFirstSession() {
  return useSessionStorage(IS_FIRST_SESSION_KEY, false);
}
